var map = {
	"./UserCollection": 472,
	"./UserCollection.js": 472,
	"./UserModel": 237,
	"./UserModel.js": 237,
	"./csrf": 553,
	"./csrf.js": 553,
	"./global_translations": 554,
	"./global_translations.js": 554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 878;